import { THEME_TYPE } from 'core/constants'
import { TypeConfig, defaultConfig } from '../../core/style/theme'

import UAParser from 'ua-parser-js'

let _partnerId = ''
const _params = _initParam()
const _cookies = _initCookie()

export const setPartnerId = (value: string) => {
  _partnerId = value
}

export const getPartnerId = () => {
  return _partnerId
}

let _accessToken: string | undefined
export const setAccessToken = (value: string | undefined) => {
  _accessToken = value
}

export const getAccessToken = () => {
  return _accessToken
}

let _memberId: string | undefined
export const setMemberId = (value: string) => {
  _memberId = value
}

export const getMemberId = () => {
  return _memberId
}

let _memberType: string | undefined
export const setMemberType = (value: string) => {
  _memberType = value
}

export const getMemberType = () => {
  return _memberType
}

let _age: string | undefined
export const setAge = (value: string) => {
  _age = value || 'etc'
}

export const getAge = () => {
  return _age || 'etc'
}

let _gender: string | undefined
export const setGender = (value: string) => {
  _gender = value
}

export const getGender = () => {
  return _gender
}

let _config: TypeConfig = defaultConfig
export const setConfig = (config: TypeConfig) => {
  _config = config
}

export const getConfig = () => {
  return _config
}
let _themeType: THEME_TYPE = THEME_TYPE.DEFAULT
export const setChangedTheme = (theme: THEME_TYPE) => {
  _themeType = theme
}

export const getThemeType = () => {
  return _themeType
}

/**
 * @name userAgent관련
 */
function _initUA() {
  const ua = new UAParser()
  const broswer = ua.getBrowser().name
  const os = ua.getOS().name
  const engine = ua.getEngine().name
  const userAgent = navigator.userAgent
  const { model, vendor } = ua.getDevice()

  const isAOS = os === 'Android'
  const isBrowserWebsiteRequestingOnIOS =
    navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const isIOS = os === 'iOS' || isBrowserWebsiteRequestingOnIOS
  const partner = [/addheader/gi, /hanatourApp/gi, /eshop-android/gi, /eshop-ios/gi]
  const isSDKAndroid = /sauce-sdk-android/gi.test(userAgent)
  const isSDKIOS = /sauce-sdk-ios/gi.test(userAgent)

  const isMobile =
    isAOS || isIOS || partner.some((x) => x.test(navigator.userAgent)) || isSDKAndroid || isSDKIOS

  const isWebview =
    (isAOS && broswer === 'Chrome WebView') ||
    (isIOS && /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)) ||
    partner.some((x) => x.test(navigator.userAgent)) ||
    isSDKAndroid ||
    isSDKIOS

  const isSupportWebview = /naver|kakaotalk|daum|instagram/gi.test(navigator.userAgent)

  const isIframe = window.location !== window.parent.location

  const isSDK = isSDKAndroid || isSDKIOS

  return {
    broswer,
    os,
    vendor,
    engine,
    model,
    isAOS,
    isIOS,
    isMobile,
    isWebview,
    isSupportWebview,
    isIframe,
    isSDK,
    isSDKAndroid,
    isSDKIOS,
  }
}
const _ua = _initUA()

export const getUA = () => {
  return _ua
}

/**
 * @name 파라미터관련
 * @description hashRouter 세팅시 param 처리는 URL 을 파싱하여 사용
 */
function _initParam() {
  const obj: { [key: string]: string | undefined } = {}
  const isHashRouter = window.location.href.includes('#/')
  const urlParams = isHashRouter
    ? new URLSearchParams(window.location.href.split('#/')[1])
    : new URLSearchParams(window.location.search)
  urlParams.forEach((value, key) => (obj[key] = value))
  return obj
}

function _getParam(key: string): string | undefined
function _getParam(): { [key: string]: string }
function _getParam(key?: string) {
  return key ? _params[key] : _params
}
export const getParam = _getParam

/**
 *  @name 쿠키관련
 */
function _initCookie() {
  const cookies = document.cookie.split('; ')
  return cookies.reduce((pre, cur) => {
    const [key, value] = cur.split('=')
    pre[key] = value
    return pre
  }, {} as { [key: string]: string | undefined })
}

function _getCookie(key: string): string | undefined
function _getCookie(): { [key: string]: string }
function _getCookie(key?: string) {
  return key ? _cookies[key] : _cookies
}
export const getCookie = _getCookie

export function setCookie(key: string, value: string, expire?: Date) {
  document.cookie = `${key}=${value};path=/${
    expire ? `;expires=${expire}` : ''
  };SameSite=None;Secure`
}

export const deleteCookie = (key: string) => {
  const cookie = getCookie(key)
  cookie && setCookie(key, cookie, new Date(1))
}

/**
 *  @name GA이벤트'purchase'비활성화파트너목록
 */
const _partnerListOfGaPurchaseEventDisabled = ['dongwonmall']
const _getPartnerListOfGaPurchaseEventDisabled = () => _partnerListOfGaPurchaseEventDisabled
export const getPartnerListOfGaPurchaseEventDisabled = _getPartnerListOfGaPurchaseEventDisabled

export const preCheckTokenValidation = (date: Date) => {
  const currentDate = new Date()
  const sixMonthsAgo = new Date()

  // Set the date to 6 months ago
  sixMonthsAgo.setMonth(currentDate.getMonth() - 6)

  // Check if the given date is older than 6 months ago
  return date < sixMonthsAgo
}
